import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useCollectionTexts = () =>
  useQuery({ queryKey: ["collection-texts"], queryFn: async () => (await api.get("/collections/texts")).data ?? {}, staleTime: 60_000 });
